import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Course } from 'src/app/models/course';
import { PracticeService } from 'src/app/services/practice.service';

@Component({
  selector: 'app-practice-content-picker',
  templateUrl: './practice-content-picker.component.html',
  styleUrls: ['./practice-content-picker.component.scss']
})
export class PracticeContentPickerComponent implements OnInit {
  public practiceContent:Course[];
  public coursesToAdd:Course[];
  public practiceId;
  public coursesLoaded:boolean=false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    public dialogRef: MatDialogRef<PracticeContentPickerComponent>,
    private _practice: PracticeService
  ) {
    this.practiceId = this.data.practiceId;
  }

  ngOnInit() {
    this.getPracticeContent();
  }

  updateCoursesToAdd(event:any){
    this.coursesToAdd=event.value;
  }

  getPracticeContent(){
    this._practice.getPracticeContent(this.practiceId).subscribe(
      res=>{
        this.practiceContent=res;
        this.coursesLoaded=true;
      }
    );
  }

  submit(){
    this.dialogRef.close(this.coursesToAdd);
  }

  cancel(){
    this.dialogRef.close(false);
  }

}
